import { TncComponent } from './../tnc/tnc.component';
import { Component, Input, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IFundraiser } from '../../../../fundraiser/models/fundraiser.model';
import { DonationService, UtilService, VariablesService, VwoService } from '../../../../shared/services';
import { ActivatedRoute } from '@angular/router';
import { PaymentUtilService } from '../../../payment/services';

@Component({
  selector: 'app-donate-now',
  templateUrl: './donate-now.component.html',
  styleUrls: ['./donate-now.component.scss']
})
export class DonateNowComponent implements OnInit {

  @Input() label;
  @Input() position;
  @Input() fundraiser: IFundraiser;
  @Input() icon = false;
  @Input() isRewardSelected;
  @Input() isQR;
  @Input() updateId;
  @Input() plaformFee;
  @Input() skipFailedCase;
  @Input() openDonate = false;
  @Input() switchFundraiser = false;
  @Input() customTheme = '';
  @Input() recommendTag;
  @Input() paymentIcons;
  @Input() showBeneficiary;
  @Input() sipCause;
  @Input() inputFields;
  @Input() headerType = 'v1';
  @Input() isSipStory;
  @Input() version;
  @Input() tagLabel;
  @Input() theme;
  @Input() showLabel;
  @Input() miniStory;
  @Input() openOnload;

  @ViewChild('submitForm') public submitForm: ElementRef<HTMLFormElement>;
  @ViewChild('paymentModule', { static: true }) public paymentModule: TemplateRef<HTMLElement>;
  isLoading = false;
  isBtnClicked = false;
  dialogType = 'full';
  tncList = [204070]; // Campaigns to check for terms and conditions before opening payment popup
  qParams;

  constructor(
    public util: UtilService,
    public vars: VariablesService,
    private donationService: DonationService,
    public dialog: MatDialog,
    public actRoute: ActivatedRoute,
    public vwo: VwoService,
    private paymentUtilService: PaymentUtilService
  ) { }

  ngOnInit() {
    if (!this.fundraiser) {
      this.fundraiser = this.vars.fundraiser;
    }
    this.vars.paymentDialogType.subscribe((res) => {
      if (res) { this.dialogType = this.isQR ? 'full' : res; }
    });
    this.openDonateNow();
  }

  openDonateNow() {
    this.qParams = this.actRoute.snapshot.queryParams;
    let donateOpened = false;
    if (typeof window !== 'undefined') {
      try {
        if (Object.keys(sessionStorage).includes(`donateOpened-${this.fundraiser?.custom_tag}`)) {
          donateOpened = true;
        } else if (this.openOnload) {
          this.donateNow(this.paymentModule);
        }
      } catch (error) { }
    }
    if (this.openDonate && this.qParams.donate && !donateOpened) {
      this.donateNow(this.paymentModule);
      this.util.storage.addSessionData(`donateOpened-${this.fundraiser?.custom_tag}`, true);
    }
  }

  /**Donate now */
  public donateNow(paymentModule) {
    if (this.switchFundraiser) {
      this.vars.fundraiser = this.fundraiser;
    }
    this.isBtnClicked = true;
    if (this.isQR) {
      this.vars.qrOpened = true;
    }
    if (typeof this.showBeneficiary === 'undefined') {
      this.showBeneficiary = (this.getOrigin() === 's' || (this.getOrigin() === 'f' && this.vars.selectedKCart)) ? true : false;
    }
    if (this.tncList.includes(this.fundraiser.id)) {
      const dialogRef = this.dialog.open(TncComponent, {
        width: '100vw',
        maxWidth: '600px',
        height: '100vh',
        maxHeight: this.util.isMobile() ? 'auto' : '600px',
        panelClass: 'payment-tnc-dialog',
        data: { id: this.fundraiser.id },
        autoFocus: false
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.openPaymentModule(paymentModule);
        }
      });
    } else {
      this.openPaymentModule(paymentModule);
    }
    if (!this.qParams?.sip_story) {
      this.paymentUtilService.contributeInitiatedEvents(this.position);
    }
  }
  private openPaymentModule(paymentModule: any) {
    setTimeout(() => {
      this.isLoading = true;
    }, 0);
    this.dialog.open(paymentModule, {
      width: '100vw',
      maxWidth: '660px',
      minHeight: '550px',
      height: this.util.isMobile() ? '100vh' : 'auto',
      maxHeight: this.util.isMobile() ? 'auto' : 'calc(100vh - 50px)',
      panelClass: this.vars.showKCart && !this.util.isMobile() && this.vars.pageName.match('stories|mini_story') ? ['payment-dialog', 'k-kart-pay'] : 'payment-dialog',
      disableClose: true,
      closeOnNavigation: false
    }).afterOpened().subscribe(() => {
      setTimeout(() => { this.isLoading = false; }, 0);
    });
  }

  checkSupportingStatus() {
    let returnVal = false;
    if (this.fundraiser && this.fundraiser.support_campaign && this.fundraiser.support_campaign.status_flag !== '1') {
      returnVal = true;
    }
    return returnVal;
  }

  /**Submit the donation requirement to the
   * mobile site
   */
  submitDOnationsToMobileSite() {
    const inputs = [
      { name: 'fmd_id', value: this.fundraiser.id },
    ];
    this.donationService.donateNow(inputs);
  }
  getOrigin() {
    switch (this.vars.pageName) {
      case 'stories':
        return 's';
      case 'mini_story':
        return 's';
      case 'campaign':
        return 'f';
      case 'update':
        return 'up';
    }
  }
}
